import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DEFAULT_VALUE_OPTION,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
  InputCheckboxMaster,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";
import { useInitialTarif } from "App/hooks";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_KELAS_KUNJUNGAN = {
  id: "",
  tarif_id: "",
  name: "",
  remark: "-",
  status: 1,
};

export const getAllKelasKunjungan = async () => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.kelas_kunjungan.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteKelasKunjunganById = async (
  id,
  setNewData,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.kelas_kunjungan.delete,
      {},
      {
        headers: {
          idkelaskunjungan: id,
        },
      }
    );
    setNewData();
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_KELAS_KUNJUNGAN);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  setNewData,
  formData,
  setFormData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const tarif = useInitialTarif(false);

  const addKelasKunjungan = async () => {
    return instance2.post(LIST_URL_MASTER.kelas_kunjungan.add, {
      ...formData,
    });
  };

  const updateKelasKunjungan = () => {
    return instance2.post(
      LIST_URL_MASTER.kelas_kunjungan.update,
      {
        ...formData,
      },
      {
        headers: {
          idkelaskunjungan: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addKelasKunjungan();
        } else if (formData.id !== "") {
          await updateKelasKunjungan();
        }
        setNewData();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Kelas Kunjungan`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='NAMA'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name='tarif_id'
              label='TARIF'
              id='tarif_id'
              withSearch={false}
              value={formData.tarif_id}
              onChange={handleChange("tarif_id")}
              data={tarif?.length > 0 ? tarif : [DEFAULT_VALUE_OPTION("Tarif")]}
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='REMARK'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>

          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
